<template>
  <div
    class="list-header"
    id="toplist"
    :class="{ act: selectedCount, a1: showA1 }"
  >
    <div
      class="item-header"
      :class="[
        { 'item-check-header-selected': selectedCount },
        { 'item-check-header-no-selected': !selectedCount },
      ]"
    >
      <div class="checkbox" @click="toggleSelectAll">
        <i class="ti-check"></i>
      </div>
      <div
        class="item-selected-number"
        style="display: block"
        v-if="selectedCount"
      >
        已选择{{ selectedCount }}项
      </div>
    </div>

    <div
      v-for="header in headers"
      :key="header.id"
      class="item-header"
      :class="'item-' + header.class + '-header'"
      v-show="
        !selectedCount &&
        (isList || header.id === 1) &&
        header.display.indexOf(tab) > -1
      "
      @click="sortByHeader(header.id)"
    >
      <div class="file-icon" v-if="header.id === 1">
        <i class="fa fa-file-o"></i>
      </div>
      <p>{{ header.title }}</p>
      <span class="sort" :class="header.sort" v-show="header.showSort"></span>
    </div>

    <div class="item-header item-menu-header" v-if="!selectedCount">
      <p></p>
    </div>

    <div
      class="item-selected-menu"
      style="display: block"
      v-show="selectedCount && isBackUp"
    >
      <a v-show="hasDownloadResourcePermission" @click="downloadSelecteds">
        <i class="ti-download"></i>
        下载
      </a>
      <a @click="handleData('share2')" v-if="right__share_create && (showOnFile || showOnStar)">
        <i class="iconfont icon-share"></i>
        分享
      </a>
      <a
        @click="handleShareTargetData('shareinfo')"
        v-if="(showOnShareme || showOnGroupShare) && selectedCount === 1"
      >
        <i class="iconfont icon-file"></i>
        分享详情
      </a>
      <a
        @click="handleLinkData('shareinfo')"
        v-if="showOnGroupSend && selectedCount === 1"
      >
        <i class="iconfont icon-file"></i>
        发布详情
      </a>
      <a
        v-if="right__share_remove && (showOnShareme || (showOnGroupShare && hasDeleteSharePermission))"
        @click="removeShares"
      >
        <i class="iconfont icon-trash"></i>
        移除分享
      </a>
      <a
        @click="handleLinkData('send_edit')"
        v-if="
          right__link && (showOnGroupSend && selectedCount === 1 && hasEditPublishPermission)
        "
      >
        <i class="ti-pencil-alt"></i>
        编辑发布
      </a>
      <a
        v-if="right__link_delete && (showOnGroupSend && hasDeletePublishPermission)"
        @click="deleteLinks"
      >
        <i class="iconfont icon-trash"></i>
        取消发布
      </a>
      <a v-if="right__operationFileOrFolder && (showOnFile || showOnStar)" @click="recycleFileOrFolder">
        <i class="iconfont icon-trash"></i>
        删除
      </a>
      <a v-if="right__operationFileOrFolder && hasDeleteResourcePermission" @click="deleteFileOrFolder">
        <i class="iconfont icon-trash"></i>
        删除
      </a>
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="handleMoveTreeData('restore2')">
        <i class="ti-back-left"></i>
        还原
      </a>
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="deleteFileOrFolder">
        <i class="iconfont icon-trash"></i>
        彻底删除
      </a>
      <div
        class="dropdown"
        v-if="
          showMoreBtn && (showOnFile || showOnStar || showOnGroupFile) && selectedCount !== 0
        "
      >
        <a
          class="dropdown-toggle"
          id="dropdownMenu2"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <i class="iconfont icon-more"></i>
          更多
        </a>
        <ul
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenu2"
        >
          <li
            v-if="
              right__rename && (showOnFile || showOnStar || hasRenameCloudResourcePermission) &&
              selectedCount === 1
            "
            @click="handleSelectedRename"
          >
            <a>
              <i class="iconfont icon-send"></i>
              重命名
            </a>
          </li>
          <!-- <li v-if="right__operationFileOrFolder && (showOnFile || showOnStar)">
            <a @click="handleCopyTreeData('copy2')">
              <i class="iconfont icon-copy"></i>
              复制到
            </a>
          </li> -->
          <li v-if="right__operationFileOrFolder && (showOnFile || showOnStar)">
            <a @click="handleMoveTreeData('move2')">
              <i class="iconfont icon-move"></i>
              移动到
            </a>
          </li>
          <li v-if="right__group_resource_savetocloud && hasSaveResourceToCloudResourcePermission">
            <a @click="handleSaveSelected">
              <i class="ti-harddrives"></i>
              保存到
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileInfo, download } from "@/api/drive/drive";
import { listToTree, listToTreeForCopy } from "@/utils/index";
import { getRolePermissions } from "@/utils/permission";
import { shareTargetInfo, linkInfo } from "@/api/share/share";
export default {
  name: "TableHeaderFile",
  components: {},
  props: {
    isList: Boolean,
  },
  data() {
    return {
      showA1: false,
    };
  },
  created() {
    // 初始化排序规则（按修改时间倒序）
    // this.$store.commit("sortById", 3);
  },
  computed: {
    showMoreBtn () {
      return (this.right__rename && (this.showOnFile || this.showOnStar || this.hasRenameCloudResourcePermission) &&
              this.selectedCount === 1)
        || (this.right__operationFileOrFolder && (this.showOnFile || this.showOnStar))
        || (this.right__group_resource_savetocloud && this.hasSaveResourceToCloudResourcePermission)
     },
    right__link_delete () {
      return this.$store.getters.right__link_delete
    },
    right__link () {
      return this.$store.getters.right__link
    },
    right__share_remove () {
      return this.$store.getters.right__share_remove
    },
    right__share_create () {
      return this.$store.getters.right__share_create
    },
    right__group_resource_savetocloud () {
      return this.$store.getters.right__group_resource_savetocloud
    },
    right__rename () {
      return this.$store.getters.right__rename
    },
    right__operationFileOrFolder () {
      return this.$store.getters.right__operationFileOrFolder
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    isBackUp() {
      let status = true;
      this.selectedDatas.map(function (item) {
        if (item.number == "0" && item.disk_type === "backup") {
          status = false;
        }
      });
      return status;
    },
    headers() {
      return this.$store.state.drive.headers;
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    group() {
      return this.$store.state.drive.group;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    showDownload() {
      let status = true;
      this.selectedDatas.map(function (item) {
        if (item.type === "folder") {
          status = false;
        }
      });
      return (
        status && (this.showOnFile || this.showOnStar || this.showOnGroupFile)
      );

      // let folderNums = 0;
      // this.selectedDatas.map(function(item) {
      //   if (item.type === "folder") {
      //     folderNums++;
      //   }
      // });
      // // 仅支持多选文件或单选文件夹的时候显示下载按钮
      // let status =
      //   folderNums > 1 ||
      //   (folderNums === 1 && this.selectedDatas.length > 1)
      //     ? false
      //     : true;
      // return (
      //   status && (this.showOnFile || this.showOnStar || this.showOnGroupFile)
      // );
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    selectedCount() {
      return this.selectedDatas.length;
    },
    showOnFile: function () {
      return this.tab === "file" || this.tab === "persona-file";
    },
    showOnStar: function () {
      return this.tab === "star";
    },
    showOnTrash: function () {
      return this.tab === "trash";
    },
    showOnShareme: function () {
      return this.tab === "shareme";
    },
    showOnGroupFile: function () {
      return this.tab === "group-file" || this.tab === "groupdisk-file";
    },
    showOnGroupShare: function () {
      return this.tab === "group-share" || this.tab === "groupdisk-share";
    },
    showOnGroupSend: function () {
      return this.tab === "group-send" || this.tab === "groupdisk-send";
    },
    showOnGroupFileAndSelf() {
      let status = true;
      let user_number = this.user.user_number;
      this.selectedDatas.map(function (item) {
        if (item.creater_user_number !== user_number) {
          status = false;
        }
      });
      return (
        this.tab === "groupdisk-file" &&
        this.group &&
        (status || this.group.group_member_identity === "owner")
      );
    },
    showOnGroupSendAndSelf() {
      let status = true;
      let user_number = this.user.user_number;
      this.selectedDatas.map(function (item) {
        if (item.share_creater_number !== user_number) {
          status = false;
        }
      });
      return (
        this.tab === "groupdisk-send" &&
        this.group &&
        (status || this.group.group_member_identity === "owner")
      );
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 移除分享
    hasDeleteSharePermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.permissions.public_operations.indexOf("deleteOtherShare") > -1) {
        return true;
      }
      let status = true;
      for (
        let index = 0, count = this.selectedDatas.length;
        index < count;
        index++
      ) {
        const item = this.selectedDatas[index];
        if (item.share_creater_number != this.user.user_number) {
          status = false;
          break;
        }
      }
      return status;
    },
    // 编辑发布
    hasEditPublishPermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      if (this.selectedDatas[0].link_creater_number == this.user.user_number) {
        return true;
      }
      return false;
    },
    // 取消发布
    hasDeletePublishPermission() {
      if (this.permissions.public_operations == "ALL") {
        return true;
      }
      let status = true;
      for (
        let index = 0, count = this.selectedDatas.length;
        index < count;
        index++
      ) {
        const item = this.selectedDatas[index];
        if (item.link_creater_number != this.user.user_number) {
          status = false;
          break;
        }
      }
      return status;
    },
    selectedDataPassed() {
      // 必须在群盘中
      if (
        this.tab != "groupdisk-file" ||
        !this.group ||
        this.selectedCount != 1
      ) {
        return false;
      }
      // 群主拥有所有权限
      if (
        this.permissions.public_operations == "ALL" ||
        this.group.group_member_identity === "owner"
      ) {
        return true;
      }
      return false;
    },
    // 权限-重命名
    hasRenameCloudResourcePermission() {
      // 必须在群盘中
      if (
        this.tab != "groupdisk-file" ||
        !this.group ||
        this.selectedCount != 1
      ) {
        return false;
      }
      // 群主拥有所有权限
      if (
        this.permissions.public_operations == "ALL" ||
        this.group.group_member_identity === "owner"
      ) {
        return true;
      }
      let number = this.selectedDatas[0].number;
      if (this.selectedDatas[0].parent_number != "0") {
        number = this.selectedDatas[0].parent_path_number.slice(1, 37);
      }
      // 被选中的资源必须拥有该权限
      let resource = this.permissions.resource_operations.find((item) => {
        return item.folder_id === number;
      });
      if (resource) {
        const permissions = getRolePermissions(resource.role_type);
        return permissions.indexOf("renameFile") > -1;
      }
      return false;
    },
    // 权限-保存到
    hasSaveResourceToCloudResourcePermission() {
      if (this.tab != "groupdisk-file" || !this.group) {
        return false;
      }
      // 群主拥有所有权限
      if (
        this.permissions.public_operations == "ALL" ||
        this.group.group_member_identity === "owner"
      ) {
        return true;
      }
      // 被选中的所有资源必须拥有该权限
      for (
        let index = 0, len = this.selectedDatas.length;
        index < len;
        index++
      ) {
        let number = this.selectedDatas[index].number;
        if (this.selectedDatas[index].parent_number != "0") {
          number = this.selectedDatas[index].parent_path_number.slice(1, 37);
        }
        // 被选中的资源必须拥有该权限
        const resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          const permissions = getRolePermissions(resource.role_type);
          if (permissions.indexOf("saveResourceToCloud") > -1) {
            continue;
          }
          return false;
        }
        return false;
      }
      return true;
    },
    // 权限-删除文件/文件夹
    hasDeleteResourcePermission() {
      if (this.tab != "groupdisk-file" || !this.group) {
        return false;
      }
      // 群主拥有所有权限
      if (
        this.permissions.public_operations == "ALL" ||
        this.group.group_member_identity === "owner"
      ) {
        return true;
      }
      // 被选中的所有资源必须拥有该权限
      for (
        let index = 0, len = this.selectedDatas.length;
        index < len;
        index++
      ) {
        let number = this.selectedDatas[index].number;
        if (this.selectedDatas[index].parent_number != "0") {
          number = this.selectedDatas[index].parent_path_number.slice(1, 37);
        }
        // 被选中的资源必须拥有该权限
        const resource = this.permissions.resource_operations.find((item) => {
          return item.folder_id === number;
        });
        if (resource) {
          const permissions = getRolePermissions(resource.role_type);
          if (permissions.indexOf("deleteResource") > -1) {
            continue;
          }
          return false;
        }
        return false;
      }
      return true;
    },
    // 权限-下载
    hasDownloadResourcePermission() {
      if (this.showOnFile || this.showOnStar) {
        // 云盘中仅下载文件
        for (
          let index = 0, len = this.selectedDatas.length;
          index < len;
          index++
        ) {
          if (this.selectedDatas[index].type === "folder") {
            return false;
          }
        }
        return true;
      } else {
        // 必须在群盘中
        if (this.tab != "groupdisk-file" || !this.group) {
          return false;
        }
        // 群主拥有所有权限
        if (
          this.permissions.public_operations == "ALL" ||
          this.group.group_member_identity === "owner"
        ) {
          // 被选中的所有资源必须是非文件夹，且必须拥有该权限
          for (
            let index = 0, len = this.selectedDatas.length;
            index < len;
            index++
          ) {
            if (this.selectedDatas[index].type === "folder") {
              return false;
            }
          }
          return true;
        }
        // 被选中的所有资源必须是非文件夹，且必须拥有该权限
        for (
          let index = 0, len = this.selectedDatas.length;
          index < len;
          index++
        ) {
          if (this.selectedDatas[index].type === "folder") {
            return false;
          }

          let number = this.selectedDatas[index].number;
          if (this.selectedDatas[index].parent_number != "0") {
            number = this.selectedDatas[index].parent_path_number.slice(1, 37);
          }
          // 被选中的资源必须拥有该权限
          const resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            if (permissions.indexOf("downloadResource") > -1) {
              continue;
            }
          }
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    handleSaveSelected() {
      this.$emit("handleSaveSelected");
    },
    // 批量删除发布
    deleteLinks() {
      this.$confirm({
        type: "confirm",
        content: `确定取消发布吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let link_list = this.selectedDatas.map((item) => {
            return item.link_number;
          });
          this.$store
            .dispatch("deleteLinks", {
              link_list: link_list,
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder");
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder");
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    // 批量删除分享
    removeShares() {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let sharer_target_number;
          switch (this.tab) {
            case "shareme":
              sharer_target_number = this.user.user_number;
              break;
            case "groupdisk-share":
              sharer_target_number = this.$store.state.drive.group.group_number;
              break;
          }
          let share_number = this.selectedDatas.map((item) => {
            return item.share_number;
          });
          this.$store
            .dispatch("removeShares", {
              share_number: share_number,
              sharer_target_number: sharer_target_number,
            })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder");
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder");
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    deleteFileOrFolder() {
      this.$confirm({
        type: "confirm",
        content: `确定彻底删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let files_list = this.selectedDatas.map(function (item) {
            return {
              number: item.number,
              type: item.type,
            };
          });
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: "delete",
            disk_type: "cloud",
            files_list: files_list,
          });
          this.$store
            .dispatch("handleFileOrFolder")
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder");
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder");
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    // 发布详情
    handleLinkData(action) {
      linkInfo({
        link_number: this.selectedDatas[0].link_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder");
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享详情
    handleShareTargetData(action) {
      shareTargetInfo({
        share_number: this.selectedDatas[0].share_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("#" + action).modal("show");
          } else if (res.status_code === 410) {
            this.$message({
              type: "error",
              message: res.message,
            });
            this.$store.commit("deleteFileOrFolder");
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    handleData(action) {
      let lockFile = this.selectedDatas.find((item) => item.is_lock);
      if (lockFile && lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      $("#" + action).modal("show");
    },
    handleMoveTreeData(action) {
      let lockFile = this.selectedDatas.find((item) => item.is_lock);
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.getMoveTree(action);
    },
    handleCopyTreeData(action) {
      let lockFile = this.selectedDatas.find((item) => item.is_lock);
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.getCopyTree(action);
    },
    getCopyTree(action) {
      let that = this;
      getFileInfo({
        group_number: this.groupNumber,
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: this.groupNumber ? "我的群盘" : "我的云盘",
              state: {
                selected: true,
              },
              nodes: listToTreeForCopy(res.entity.datas, this.selectedDatas),
            },
          ];
          that.$store.commit("selectedFolder", tree[0]);
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getMoveTree(action) {
      getFileInfo({
        group_number: this.groupNumber,
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: this.groupNumber ? "我的群盘" : "我的云盘",
              selectable:
                this.selectedDatas[0].parent_number === "0" &&
                this.selectedDatas[0].disk_type === "cloud" &&
                action != "restore2"
                  ? false
                  : true,
              nodes: listToTree(
                res.entity.datas,
                action == "restore2" ? [] : this.selectedDatas
              ),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: (event, data) => {
              this.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: (event, data) => {
              this.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    downloadSelecteds() {
      let lockFile = this.selectedDatas.find((item) => item.is_lock);
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }

      // let hasFolder = this.selectedDatas.some(item => item.type === "folder");
      // if (hasFolder) {
      //   // 打开本地客户端下载
      //   let numbers = this.selectedDatas
      //     .map(item => {
      //       return JSON.stringify({
      //         number: item.number,
      //         name: item.name,
      //         bytes: item.bytes,
      //         type: item.type,
      //         file_ext: item.file_ext
      //       });
      //     })
      //     .join(",");
      //   window.location.href = `rec://,${numbers}`;
      //   return false;
      // }
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadSelectedsByStep();
      }
    },
    downloadSelectedsByStep() {
      this.selectedDatas.map((data) => {
        download({
          files_list: [data.number],
          group_number: this.groupNumber,
        })
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              // setTimeout(() => {
              //   iframe.remove();
              // }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    handleSelectedRename() {
      this.$store.commit("setFocusState", false);
      let lockFile = this.selectedDatas.find((item) => item.is_lock);
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.$store.commit("handleSelectedRename");
      this.$nextTick(function () {
        this.$store.commit("setFocusState2", {
          status: true,
          data: this.selectedDatas[0],
        });
      });
    },
    sortByHeader(id) {
      this.$store.commit("sortById", id);
      this.$store.commit("sortByHeader");
    },
    recycleFileOrFolder() {
      this.$confirm({
        type: "confirm",
        content: "确定删除吗？",
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store
            .dispatch("deleteFileOrFolders")
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$store.commit("deleteFileOrFolder");
              } else if (res.status_code === 410) {
                this.$store.commit("deleteFileOrFolder");
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    toggleSelectAll() {
      this.$store.commit("toggleSelectAll");
    },
  },
  mounted() {
    let toplist_height;
    if (this.$store.state.drive.drive === "persona") {
      return false;
    } else if (this.$store.state.drive.drive === "groupdisk") {
      toplist_height = 383;
    } else {
      /*滚动停留*/
      toplist_height = $("#toplist").offset().top; //获取div1的高度
    }
    let that = this;
    //滚动处理div
    $(window).scroll(function () {
      let this_scrollTop = $(this).scrollTop();
      if (this_scrollTop > toplist_height) {
        that.showA1 = true;
      }
      if (this_scrollTop < toplist_height) {
        that.showA1 = false;
      }
    });
  },
};
</script>

<style scoped>
</style>